<template>
  <a-form-model
    ref="editPassForm"
    :rules="rules"
    :model="form"
    :label-col="{ span: 3 }"
  >
    <a-form-model-item
      label="旧密码:"
      prop="oldPass"
    >
      <a-input
        :maxLength="18"
        v-model="form.oldPass"
        type="password"
        placeholder="请输入旧密码"
        autocomplete="off"
      ></a-input>
    </a-form-model-item>
    <a-form-model-item
      label="新密码:"
      prop="newPass"
    >
      <a-input
        @click="!tip && (tip = true)"
        @blur="tip = false"
        v-model="form.newPass"
        :type="!showPass ? 'password' : ''"
        :maxLength="18"
        placeholder="请输入新密码"
        autocomplete="off"
      >
        <a-tooltip
          :overlayClassName="'newPwdTooltips'"
          slot="suffix"
          v-model="tip"
          trigger="click"
          placement="right"
        >
          <template slot="title">
            <div>
              <div
                class="tips-item"
                :class="{ red: !passValid.len }"
              >
                <SvgIcon
                  style="width: 16px;height: 16px; margin-right: 8px;"
                  :iconClass="passValid.len ? 'pwdChecked' : 'pwdError'"
                />
                <p>新密码长度为6-18字符</p>
              </div>
              <div
                class="tips-item"
                :class="{ red: !passValid.complex }"
              >
                <SvgIcon
                  style="width: 16px;height: 16px; margin-right: 8px;"
                  :iconClass="passValid.complex ? 'pwdChecked' : 'pwdError'"
                />
                <p>字母/数字以及标点符号至少包含2种</p>
              </div>
              <!-- <p :class="{ red: !passValid.len }">长度为6-18个字符</p>
              <p :class="{ red: !passValid.complex }">字母/数字以及标点符号至少包含2种</p> -->
            </div>
          </template>
        </a-tooltip>
      </a-input>
      <SvgIcon
        style="width: 16px; height: 16px;"
        class="iconStyle"
        :iconClass="!showPass ? 'hidePwd' : 'showPwd'"
        @click.stop="showPass = !showPass"
      />
    </a-form-model-item>
    <a-form-model-item
      label="确认新密码:"
      prop="repPass"
    >
      <a-input
        @click="!checkTip && (checkTip = true)"
        @blur="checkTip = false"
        v-model="form.repPass"
        :type="!showCheckPass ? 'password' : ''"
        :maxLength="18"
        placeholder="请再次输入新密码"
        autocomplete="off"
      >
        <a-tooltip
          :overlayClassName="'newPwdTooltips'"
          slot="suffix"
          v-model="checkTip"
          trigger="click"
          placement="right"
        >
          <template slot="title">
            <div>
              <div
                class="tips-item"
                :class="{ red: !checkPassValid.len }"
              >
                <SvgIcon
                  style="width: 16px;height: 16px; margin-right: 8px;"
                  :iconClass="checkPassValid.len ? 'pwdChecked' : 'pwdError'"
                />
                <p>新密码长度为6-18字符</p>
              </div>
              <div
                class="tips-item"
                :class="{ red: !checkPassValid.complex }"
              >
                <SvgIcon
                  style="width: 16px;height: 16px; margin-right: 8px;"
                  :iconClass="checkPassValid.complex ? 'pwdChecked' : 'pwdError'"
                />
                <p>字母/数字以及标点符号至少包含2种</p>
              </div>
              <div
                class="tips-item"
                :class="{ red: !checkPassValid.same }"
              >
                <SvgIcon
                  style="width: 16px;height: 16px; margin-right: 8px;"
                  :iconClass="checkPassValid.same ? 'pwdChecked' : 'pwdError'"
                />
                <p>两次输入密码一致</p>
              </div>
            </div>
          </template>
        </a-tooltip>
      </a-input>
      <SvgIcon
        style="width: 16px; height: 16px;"
        class="iconStyle"
        :iconClass="!showCheckPass ? 'hidePwd' : 'showPwd'"
        @click.stop="showCheckPass = !showCheckPass"
      />
    </a-form-model-item>
    <a-form-model-item :wrapper-col="{ offset: 3 }">
      <a-button
        style="width: 84px;"
        type="primary"
        @click="save('editPassForm')"
      >
        保存
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
import { modifyPass } from '@/api/user'
// const reg = /(?=.*[0-9])(?=.*[a-zA-Z]).{6,18}/
import { passReg, passComplexReg } from '@/utils/regs'
export default {
  name: '',
  components: { SvgIcon },
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!passReg.test(value)) {
        callback(new Error('密码设置格式不符合'))
      } else if (value !== this.form.newPass) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    }
    return {
      showCheckPass: false,
      showPass: false,
      form: {
        oldPass: '',
        newPass: '',
        repPass: ''
      },
      rules: {
        oldPass: [
          { required: true, message: '请输入密码', trigger: 'none' }
          //   { pattern: reg, message: '密码设置格式不符合', trigger: ['blur', 'change'] }
        ],
        newPass: [
          { required: true, message: '请输入密码', trigger: 'none' },
          { pattern: passReg, message: '密码设置格式不符合', trigger: 'none' }
        ],
        repPass: [{ validator: validatePass, trigger: 'none' }]
      },
      tip: false,
      checkTip: false,
      checkPassValid: {
        len: false,
        complex: false,
        same: false
      },
      passValid: {
        len: false,
        complex: false
      }
    }
  },
  watch: {
    'form.newPass' (val) {
      this.checkPassValid.same = this.form.newPass === this.form.repPass
      if (!val.trim()) {
        this.passValid.len = false
        this.passValid.complex = false
        this.passValid.same = false
        return
      }
      if (val.trim().length > 5 && val.trim().length < 19) {
        this.passValid.len = true
      } else {
        this.passValid.len = false
      }
      this.passValid.complex = passComplexReg.test(val.trim())
    },
    'form.repPass' (val) {
      if (!val.trim()) {
        this.checkPassValid.len = false
        this.checkPassValid.complex = false
        this.checkPassValid.same = false
        return
      }
      if (val.trim().length > 5 && val.trim().length < 19) {
        this.checkPassValid.len = true
      } else {
        this.checkPassValid.len = false
      }
      this.checkPassValid.complex = passComplexReg.test(val.trim())
      this.checkPassValid.same = this.form.newPass === this.form.repPass
    }
  },
  methods: {
    resetForm () {
      this.form.oldPass = ''
      this.form.newPass = ''
      this.form.repPass = ''
    },
    save (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            const { oldPass: oldPassword, repPass: newPassword, } = this.form
            const res = await modifyPass({ oldPassword, newPassword })
            console.log(res)
            if (res) {
              this.$store.dispatch('logout')
              this.$message.success('修改成功')
              setTimeout(() => {
                this.$router.replace({ name: 'login' })
                this.resetForm()
              }, 500)
            }
          } catch (error) {
            console.log(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less">
.newPwdTooltips {
  .ant-tooltip-arrow {
    &::before {
      background-color: #fff !important;
    }
  }
  .ant-tooltip-inner {
    background-color: #fff;
    color: #303133;

    .tips-item {
      font-size: 14px;
      display: flex;
      align-items: center;
      &.red {
        color: #ef463a;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.red {
  color: #f55;
}
/deep/.ant-form-item-required {
  &::before {
    content: '';
  }
  &::after {
    content: '';
    margin-right: 22px;
  }
}
.ant-form-item {
  display: flex;
  width: 100%;
  margin-bottom: 19px;
  &.ant-form-item-with-help {
    margin-bottom: 0;
  }
  .input-box {
    display: flex;
    align-items: center;
  }

  /deep/ .ant-form-item-label {
    line-height: 36px;
  }
  // align-items: center;
  /deep/ .ant-form-item-control-wrapper {
    padding-left: 10px;
    .ant-form-item-control {
      height: 100%;
      line-height: 36px;
      &.has-error {
          input {
            border: 1px solid #f5222d;
          }
      }
      .ant-form-explain {
        font-size: 12px;
        line-height: 22px;
        padding: 0;
      }
    }
    .iconStyle {
      width: 16px;
      height: 16px;
      position: absolute;
      right: 10px;
      top: 0px;
    }
    input {
      box-sizing: border-box;
      width: 265px;
      height: 36px;
      background: #f5f8fa;
      border-radius: 6px;
      padding-right: 30px;
      font-size: 14px;
      border: none;
    }
  }
}
</style>
